import React, { ComponentProps } from 'react'
import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'
import { Button } from 'components/Button'
import { Link } from 'components/Link'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import {
  DeliveryRoot,
  Wrapper,
  TextContent,
  DesktopImageWrapper,
  MobileImageWrapper,
  DesktopImage,
} from './Delivery.styles'

import delivery from '../../../../../public/assets/wwfr-delivery.png'

type DeliveryOwnProps = ComponentProps<typeof DeliveryRoot>
export type DeliveryProps = DeliveryOwnProps & {}

export const Delivery = (_props: DeliveryProps) => {
  const { t } = useTranslation()

  return (
    <DeliveryRoot>
      <Wrapper>
        <Stack justifyContent="space-between">
          <TextContent>
            <Stack
              gap={{ '@initial': '5', '@bp2': '4' }}
              direction="column"
              alignItems={{ '@initial': 'center', '@bp3': 'flex-start' }}
            >
              <Text
                size={{ '@initial': 'h3', '@bp3': 'h1' }}
                as="h3"
                weight="bold"
                color="tertiary-200"
                align={{ '@initial': 'center', '@bp3': 'left' }}
              >
                {t('why-we-feed-raw:delivery.title')}
              </Text>
              <MobileImageWrapper>
                <Image src={delivery} alt="" />
              </MobileImageWrapper>
              <Link href="/meal-plan" passHref>
                <Button as="a">{t('why-we-feed-raw:cta-1')}</Button>
              </Link>
            </Stack>
          </TextContent>
          <DesktopImageWrapper>
            <DesktopImage>
              <Image src={delivery} alt="" />
            </DesktopImage>
          </DesktopImageWrapper>
        </Stack>
      </Wrapper>
    </DeliveryRoot>
  )
}

Delivery.displayName = 'Delivery'
